import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { ReactComponent as AtRisk } from "../../../../icons/icon_files/at_risk.svg";
import { ReactComponent as DetectionOnly } from "../../../../icons/icon_files/detection_only.svg";
import { ReactComponent as MissingControls } from "../../../../icons/icon_files/missing_controls.svg";
import { ReactComponent as OptimalProtection } from "../../../../icons/icon_files/optimal_protection.svg";
import { ReactComponent as PartialProtection } from "../../../../icons/icon_files/partial_protection.svg";
import { ReactComponent as RiskAccepted } from "../../../../icons/icon_files/risk_accepted.svg";

import CustomToolTip from "../../../../components/CustomTooltip";
import { ProtectionLevelText } from "../../../../utils/constants";

const ProtectionLevel = ({ level, tagOrFilter = "tag", shorten = false }) => {
  const colors = useColors();

  const statusConfig = {
    [ProtectionLevelText.AT_RISK]: {
      icon: <SvgToIcon IconLogo={AtRisk} width="12px" />,
      tooltip: "No mitigation controls have been applied for this step",
    },
    [ProtectionLevelText.MISSING_CONTROLS]: {
      icon: <SvgToIcon IconLogo={MissingControls} width="12px" />,
      tooltip: "This step has no protection in place",
    },
    [ProtectionLevelText.DETECTION_ONLY]: {
      icon: <SvgToIcon IconLogo={DetectionOnly} width="12px" />,
      tooltip:
        "Detect controls are applied, but no Protect controls are enforced",
    },
    [ProtectionLevelText.PARTIAL_PROTECTION]: {
      icon: <SvgToIcon IconLogo={PartialProtection} width="12px" />,
      tooltip:
        "One or more Protect controls are applied, providing partial coverage",
    },
    [ProtectionLevelText.OPTIMAL_PROTECTION]: {
      icon: <SvgToIcon IconLogo={OptimalProtection} width="12px" />,
      tooltip:
        "All applicable mitigation controls are applied, providing optimal coverage",
    },
    [ProtectionLevelText.RISK_ACCEPTED]: {
      icon: <SvgToIcon IconLogo={RiskAccepted} width="12px" />,
      tooltip:
        "This step has active gaps that have been snoozed or excluded. The risk is acknowledged and accepted by your team.",
    },
  };
  const config =
    statusConfig[level] || statusConfig[ProtectionLevelText.AT_RISK];

  const getDisplayText = (level, shorten) => {
    if (shorten && level === ProtectionLevelText.PARTIAL_PROTECTION) {
      return "Partial";
    }
    if (shorten && level === ProtectionLevelText.OPTIMAL_PROTECTION) {
      return "Optimal";
    }
    return level;
  };

  const displayText = getDisplayText(level, shorten);

  return (
    <CustomToolTip title={config.tooltip} placement="top">
      <Box
        sx={{
          borderRadius: "12px",
          border:
            tagOrFilter === "tag" ? "0.5px solid " + colors.grey_light : "none",
          alignItems: "center",
          gap: 1,
          display: "flex",
          width: "fit-content",
          height: "24px",
          padding: tagOrFilter === "tag" ? "4px 8px" : "0px",
        }}
      >
        {config.icon}
        <Typography variant={"caption"} sx={{ color: colors.text_secondary }}>
          {displayText}
        </Typography>
      </Box>
    </CustomToolTip>
  );
};

export default ProtectionLevel;
